//BB: Overall performsnce reducer 


import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// interface Overallperformance {
// courses : any,
// teacher_id : any,
// students :any,
// }

interface Overallperformance {
    students: any[];
    courses: any[];
    teacher_id: string;
    year: any,
    month: any,
    start_date: any,
    end_date: any
}

const initialState: Overallperformance = {
    courses: [],
    students: [],
    teacher_id: "",
    year: "",
    month: "",
    start_date: "",
    end_date: ""

};


const overallPerformanceByTeacherSlice = createSlice({
    name: "OverallPerformanceByTeacher",
    initialState,
    reducers: {


        setAverageScore: (state: Overallperformance, action: PayloadAction<any[]>) => {
            state.students = action.payload;



            // state.isLoading = false;
            // state.error = null;
        },
        // setPagination: (state: CourseState, action: PayloadAction<CourseState>) => {
        //     state.next = action.payload.next;
        //     state.previous = action.payload.previous;
        //     state.count = action.payload.count;
        //     state.totalPages = Math.ceil((action.payload.count ?? 0) / 12);
        //     state.isLoading = false;
        //     state.error = null;
        // },
        // setloading: (state: CourseState, action: PayloadAction<boolean>) => {
        //     state.isLoading = action.payload;
        //     state.error = null;
        // },
        // seterror: (state: CourseState, action: PayloadAction<string>) => {
        //     state.error = action.payload;
        //     state.isLoading = false;
        // },
        resetAverageScore: () => {
            return initialState;
        },
    },
});

export const {
    setAverageScore,
    // setloading,
    // seterror,
    // setPagination,
    resetAverageScore,
} = overallPerformanceByTeacherSlice.actions;

export default overallPerformanceByTeacherSlice.reducer;
